export const dataSelector = state => state.get('team').get('data');

export const userSelector = state => state.get('team').get('details');

export const visitsSelector = state => state.get('team').get('visits');
